export const GET_PRODUCT_DETAILS_BY_ID_ERROR = 'GET_PRODUCT_DETAILS_BY_ID_ERROR';
export const GET_PRODUCT_DETAILS_BY_ID_REQUEST = 'GET_PRODUCT_DETAILS_BY_ID_REQUEST';
export const GET_PRODUCT_DETAILS_BY_ID_SUCCESS = 'GET_PRODUCT_DETAILS_BY_ID_SUCCESS';
export const GET_PRODUCT_DETAILS_TIMEOUT_ERROR = 'GET_PRODUCT_DETAILS_TIMEOUT_ERROR';
